import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logOut } from '../redux/slices/auth';

const Logout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const handleLogOut = () => {
            dispatch(logOut());
            navigate('/');
        };

        handleLogOut();
    }, [dispatch, navigate]);

    return null;
}

export default Logout;
